<div class="main-content">
    <div class="header-options">
        <mat-form-field *ngIf="uid.user.companylist.length > 1" class="no-padding-form-field">
            <mat-label>Empresa</mat-label>
            <mat-select  [(ngModel)]="codecompany">
                <mat-option *ngFor="let data of uid.user.companylist" [value]="data.codecompany" (click)="loadCredential(data)">
                    {{data.codecompany}} - {{data.companyname}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="no-padding-form-field">
            <mat-label>Serviços</mat-label>
            <mat-select  [(ngModel)]="servico" [disabled]="listServices.length==0">
                <mat-option *ngFor="let data of listServices" [value]="data">
                    {{data.codigo}} - {{data.descricao}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="grid-content"  [ngClass]="{disabled: !enablePanels}">  
        <mat-grid-list cols="3" rowHeight="fit" gutterSize="10">
            <mat-grid-tile>
                <mat-card appearance="outlined" class="card-model">
                    <mat-card-header>
                        <mat-card-title>Verificar Disponibilidade</mat-card-title>
                    </mat-card-header>
                    <mat-card-content class="card-content">
                        <cep-disponibilidade [codecompany]="codecompany" [codecontract]="codecontract" [correiosAuth]="correiosAuth" [servico]="servico"></cep-disponibilidade>
                    </mat-card-content>
                </mat-card>
            </mat-grid-tile>
            <mat-grid-tile>
                <cep-consultapreco [codecompany]="codecompany" [codecontract]="codecontract" [correiosAuth]="correiosAuth" [servico]="servico" [eventUserConfig]="eventsSubject.asObservable()"></cep-consultapreco>
            </mat-grid-tile>
            <mat-grid-tile>
                <cep-buscaobjeto [codecompany]="codecompany" [codecontract]="codecontract" [correiosAuth]="correiosAuth" [servico]="servico" [eventUserConfig]="eventsSubject.asObservable()"></cep-buscaobjeto>
            </mat-grid-tile>
            <mat-grid-tile  colspan="2">
                <mat-card  appearance="outlined"  class="card-model">
                    <mat-card-header>
                        <mat-card-title>Rastreamento</mat-card-title>
                    </mat-card-header>
                </mat-card>
            </mat-grid-tile>
            <mat-grid-tile>
                <cep-range [codecompany]="codecompany" [codecontract]="codecontract" [correiosAuth]="correiosAuth" [servico]="servico" [eventUserConfig]="eventsSubject.asObservable()"></cep-range>
            </mat-grid-tile>
        </mat-grid-list>
    </div>
</div>
